import React, { Component } from 'react';
import SignupCustomer from 'components/Admin/Users/SignupCustomer';

class CustomerSignup extends Component {
    render() {
        require('bootstrap/dist/css/bootstrap.min.css')
        require('../../assets/css/animate.min.css')
        require('../../assets/sass/light-bootstrap-dashboard.css?v=1.2.0')
        require('../../assets/css/demo.css')
        require('../../assets/css/pe-icon-7-stroke.css')
        require('../../assets/fonts/robotoFont.css')
        return (
            <SignupCustomer />
        );
    }
}
export default CustomerSignup;


// WEBPACK FOOTER //
// ./src/layouts/Dashboard/CustomerSignup.jsx